import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface CityStore {
  city: string | null;        // название города
  cityLat: number | null;
  cityLng: number | null;
  hasChosen: boolean;         // пользователь уже выбрал (или отказался)
  setCity: (name: string, lat?: number, lng?: number) => void;
  clearCity: () => void;
  setHasChosen: (v: boolean) => void;
}

export const useCityStore = create<CityStore>()(
  persist(
    (set) => ({
      city: null,
      cityLat: null,
      cityLng: null,
      hasChosen: false,
      setCity: (name, lat, lng) => set({ city: name, cityLat: lat ?? null, cityLng: lng ?? null, hasChosen: true }),
      clearCity: () => set({ city: null, cityLat: null, cityLng: null }),
      setHasChosen: (v) => set({ hasChosen: v }),
    }),
    {
      name: 'city-store',
    }
  )
);
